import { inject, injectable } from 'inversify';
import {
  CreditCardsServiceInterface,
  StoreUserCreditCardParams,
  StoreUserCreditCardResponse,
  GetUserCreditCardsParams,
  GetUserCreditCardsResponse,
  DeleteCreditCardRequestParams,
  SetMainCreditCardParams,
} from './CreditCardsService.types';
import { backendUrl } from 'src/config';
import HttpClient from 'src/features/http';

@injectable()
class CreditCardsService implements CreditCardsServiceInterface {
  @inject(HttpClient) private readonly client!: HttpClient;

  public async storeUserCreditCard({
    userId,
    accessToken,
    ...data
  }: StoreUserCreditCardParams) {
    return this.client
      .getClient()
      .post<StoreUserCreditCardResponse>(`/users/${userId}/cards/`, data, {
        baseURL: backendUrl,
        headers: { Authorization: `Token ${accessToken}` },
      });
  }

  public async getUserCreditCards({
    userId,
    accessToken,
    payment_method,
  }: GetUserCreditCardsParams) {
    const params: Record<string, string> = {};

    if (payment_method) {
      params.payment_method = payment_method;
    }

    return this.client
      .getClient()
      .get<GetUserCreditCardsResponse>(`/users/${userId}/cards`, {
        baseURL: backendUrl,
        headers: { Authorization: `Token ${accessToken}` },
        params,
      });
  }

  public async deleteUserCreditCard({
    userId,
    accessToken,
    cardId,
  }: DeleteCreditCardRequestParams) {
    return this.client
      .getClient()
      .delete<void>(`/users/${userId}/cards/${cardId}`, {
        baseURL: backendUrl,
        headers: { Authorization: `Token ${accessToken}` },
      });
  }

  public setMainCreditCard({
    userId,
    cardId,
    accessToken,
  }: SetMainCreditCardParams) {
    return this.client.getClient().post<void>(
      `/users/${userId}/cards/${cardId}/set_main/`,
      {},
      {
        baseURL: backendUrl,
        headers: { Authorization: `Token ${accessToken}` },
      }
    );
  }
}

export default CreditCardsService;
